module.exports = __webpack_public_path__ + "static/itunes-colour.0f2a6908.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/itunes-colour.svg
// module id = 297
// module chunks = 95715928098905 216929306842663